import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { take } from 'rxjs/operators';

import { AuthenticationSandbox } from '../../sandbox/authentication.sandbox';

@Component({
    selector: 'med-logout-container',
    template: ''
})
export class LogoutContainerComponent implements OnInit {
    private readonly LOGOUT_URL: string;

    constructor(
        private readonly sandbox: AuthenticationSandbox,
        private readonly router: Router
    ) {}

    ngOnInit(): void {
        this.logout();
    }

    navigateToOauthLogoutPage(): void {
        this.sandbox
            .getOauthLogoutUrl()
            .pipe(take(1))
            .subscribe(logoutUrl => {
                window.location.href = logoutUrl;
            });
    }

    private logout(): void {
        this.sandbox.logout();

        if (this.sandbox.canSkipLogin()) {
            this.navigateToOauthLogoutPage();
        } else {
            this.router.navigate(['/login']);
        }
    }
}
